import type {
    TransformsStyle
} from "react-native";
import type {
    DirectionType
} from "../../types/locale";

export type DirectionSignType = 1 | -1;

export type HorizontalStepType = DirectionSignType | 0;

export type DirectionSignConstantType = {
    direction: DirectionType;
};

export type MirrorStyleConstantType = {
    direction: DirectionType;
    isMirrored?: boolean;
};

export type HorizontalStepConstantType = {
    direction: DirectionType;
    key: string;
};

export type MirroredIconConstantType = {
    name?: string;
};

const HORIZONTAL_STEPS: Record<DirectionType, Record<"ArrowRight" | "ArrowLeft", DirectionSignType>> = {
    rtl: {
        ArrowRight: -1,
        ArrowLeft: 1
    },
    ltr: {
        ArrowRight: 1,
        ArrowLeft: -1
    }
};

export const MIRRORED_ICONS: Array<string> = [
    "ArrowDownWideNarrow",
    "ListIndentIncrease",
    "ListIndentDecrease",
    "CornerDownLeft",
    "PanelLeftClose",
    "ChevronsRight",
    "MessageSquare",
    "PanelLeftOpen",
    "ChevronsLeft",
    "ChevronRight",
    "ExternalLink",
    "ChevronLeft",
    "ArrowRight",
    "ArrowLeft",
    "PanelLeft",
    "StarHalf",
    "Forward",
    "LogOut",
    "Reply",
    "Redo2",
    "Undo2",
    "LogIn",
    "Send",
    "List"
];

export const getDirectionSign = ({
    direction
}: DirectionSignConstantType): DirectionSignType => {
    return direction === "rtl" ? -1 : 1;
};

export const getMirrorStyle = ({
    isMirrored = true,
    direction
}: MirrorStyleConstantType): TransformsStyle => {
    if(!isMirrored || direction === "ltr") {
        return {};
    }

    return {
        transform: [
            {
                scaleX: getDirectionSign({
                    direction
                })
            }
        ]
    };
};

export const getHorizontalStep = ({
    direction,
    key
}: HorizontalStepConstantType): HorizontalStepType => {
    if(key === "ArrowRight" || key === "ArrowLeft") {
        return HORIZONTAL_STEPS[direction][key];
    }

    return 0;
};

export const isMirroredIcon = ({
    name
}: MirroredIconConstantType): boolean => {
    if(!name) {
        return false;
    }

    const iconName = name.split("-").map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`).join("");

    return MIRRORED_ICONS.includes(iconName);
};

export {
    syncDocumentDirection,
    syncNativeDirection
} from "./sync";

export type {
    DocumentDirectionConstantType,
    NativeDirectionConstantType
} from "./sync";

export {
    isLangDirectionConflict,
    getLanguageDirection
} from "./lang";

export type {
    LangDirectionConflictConstantType,
    LanguageDirectionConstantType
} from "./lang";
